import { useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import { PropTypes } from "prop-types";
import {
  Button,
  Collapse,
  Container,
  Nav,
  NavItem,
  NavLink,
  Navbar,
  Row,
  Col,
} from "reactstrap";

const Sidebar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState(false);

  // Verifies if routeName is the one active
  const activeRoute = (routeName) => {
    return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  // Toggles collapse
  const toggleCollapse = () => {
    setCollapseOpen(!collapseOpen);
  };

  // Closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  // Check if current user is super admin
  const isSuperAdmin = () => {
    try {
      const userData = localStorage.getItem('userData');
      if (userData) {
        const user = JSON.parse(userData);
        return user.isSuperAdmin === true;
      }
      return false;
    } catch (error) {
      console.error('Error checking super admin status:', error);
      return false;
    }
  };

  // Creates the links that appear in the left menu
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      // Hide Admin Users route if user is not super admin
      if (prop.path === '/admin-users' && !isSuperAdmin()) {
        return null;
      }
      
      return (
        <NavItem key={key}>
          <NavLink
            to={prop.layout + prop.path}
            tag={NavLinkRRD}
            onClick={closeCollapse}
          >
            <i className={prop.icon} />
            {prop.name}
          </NavLink>
        </NavItem>
      );
    }).filter(Boolean); // Remove null entries
  };

  const { bgColor, routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = { to: logo.innerLink, tag: Link };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = { href: logo.outterLink, target: "_blank" };
  }

  return (
    <Navbar
      className={`navbar-vertical fixed-left ${
        collapseOpen ? "sidebar-show" : "sidebar-hide"
      } bg-darker`}
      expand="md"
      id="sidenav-main"
    >
      <Container fluid>
        
        {/* Toggler */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <i
            className="ni ni-align-left-2 navbar-toggler-icon"
            style={{ color: "white", fontSize: "30px" }}
          />
        </button>

        {/* Brand */}
        {logo ? (
          <div className="navbar-brand">
            {logo.innerLink ? (
              <Link to={logo.innerLink}>
                <img alt={logo.imgAlt} src={logo.imgSrc} className={logo.className} style={logo.style} />
              </Link>
            ) : (
              <a href={logo.outterLink}>
                <img alt={logo.imgAlt} src={logo.imgSrc} className={logo.className} style={logo.style} title={logo.imgAlt} />
              </a>
            )}
          </div>
        ) : null}

        {/* Collapse */}
        <Collapse navbar isOpen={collapseOpen}>
          {/* Navigation */}
          <Nav navbar>{createLinks(routes)}</Nav>
        </Collapse>
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;

// import { useState } from "react";
// import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// import { PropTypes } from "prop-types";
// import {
//   Button,
//   Collapse,
//   Container,
//   Nav,
//   NavItem,
//   NavLink,
//   Navbar,
// } from "reactstrap";

// const Sidebar = (props) => {
//   const [collapseOpen, setCollapseOpen] = useState(false);

//   // Verifies if routeName is the one active
//   const activeRoute = (routeName) => {
//     return props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
//   };

//   // Toggles collapse
//   const toggleCollapse = () => {
//     setCollapseOpen(!collapseOpen);
//   };

//   // Closes the collapse
//   const closeCollapse = () => {
//     setCollapseOpen(false);
//   };

//   // Creates the links that appear in the left menu
//   const createLinks = (routes) => {
//     return routes.map((prop, key) => (
//       <NavItem key={key}>
//         <NavLink
//           to={prop.layout + prop.path}
//           tag={NavLinkRRD}
//           onClick={closeCollapse}
//         >
//           <i className={prop.icon} />
//           {prop.name}
//         </NavLink>
//       </NavItem>
//     ));
//   };

//   const { routes, logo } = props;
//   let navbarBrandProps;
//   if (logo && logo.innerLink) {
//     navbarBrandProps = { to: logo.innerLink, tag: Link };
//   } else if (logo && logo.outterLink) {
//     navbarBrandProps = { href: logo.outterLink, target: "_blank" };
//   }

//   // Inline styles
//   const sidebarStyle = {
//     transform: collapseOpen ? "translateX(0)" : "translateX(-100%)",
//     transition: "transform 0.3s ease-in-out",
//     width: "250px",
//     position: "fixed",
//     top: "0",
//     left: "0",
//     height: "100%",
//     backgroundColor: "#333",
//     color: "#fff",
//     zIndex: "1040",
//   };

//   const togglerStyle = {
//     position: "absolute",
//     top: "10px",
//     right: "-50px",
//     backgroundColor: "#333",
//     color: "#fff",
//     border: "none",
//     fontSize: "18px",
//     cursor: "pointer",
//   };

//   return (
//     <>
//       <Navbar style={sidebarStyle}>
//         <Container fluid>
//           {/* Toggler */}
          // <button
          //   style={togglerStyle}
          //   onClick={toggleCollapse}
          // >
          //   <i className="ni ni-align-left-2" />
          // </button>

//           {/* Brand */}
//           {logo ? (
//             <div className="navbar-brand">
//               {logo.innerLink ? (
//                 <Link to={logo.innerLink}>
//                   <img alt={logo.imgAlt} src={logo.imgSrc} />
//                 </Link>
//               ) : (
//                 <a href={logo.outterLink}>
//                   <img alt={logo.imgAlt} src={logo.imgSrc} />
//                 </a>
//               )}
//             </div>
//           ) : null}

//           {/* Collapse */}
//           <Collapse navbar isOpen={collapseOpen}>
//             {/* Navigation */}
//             <Nav navbar>{createLinks(routes)}</Nav>
//           </Collapse>
//         </Container>
//       </Navbar>
//     </>
//   );
// };

// Sidebar.defaultProps = {
//   routes: [{}],
// };

// Sidebar.propTypes = {
//   routes: PropTypes.arrayOf(PropTypes.object),
//   logo: PropTypes.shape({
//     innerLink: PropTypes.string,
//     outterLink: PropTypes.string,
//     imgSrc: PropTypes.string.isRequired,
//     imgAlt: PropTypes.string.isRequired,
//   }),
// };

// export default Sidebar;
